import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Pagination, Row, Select, Space, Table, Typography, message, Modal as AntModal, Col } from "antd";
import type { PaginationProps, TableProps } from "antd";
import "./FlareVolume.css";
import { BsPencilSquare, BsTrashFill } from "react-icons/bs";
import { usePagination } from "src/hook/usePagination";
import { useDidMount } from "src/hook/useDidMount";
import { useShallow } from "zustand/react/shallow";
import { CalendarOutlined, CloseOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { getFilterWithEmptyMasterdata, replaceUndefinedWithNull, trimAllKey } from "src/utils/utils-object";
import { CommonSuccess } from "src/entity/common/menus-enum.enum";
import { InfoCircleOutlined } from "@ant-design/icons";
import { ManageCompoundProps } from "src/entity/flare/heating-value.entity";
import { SentOneStackOfFlareEnum } from "src/entity/flare/flare.constants";
import { profileStore } from "src/stores/profile-store";
import { formatNumber, parseToDecimal } from "src/utils/process-number";
import { componentPalette } from "src/theme/component-palette";
import VocsModal from "src/components/Modal";
import FlareVolumeModal from "./FlareVolumeModal";
import { flareVolumeStore } from "src/stores/flare-volume-store";
import {
  CreateFlareVolume,
  FilterSetupFlareVolume,
  FormSetUpFlareVolumeProps,
  RangeDateDto,
  ResponseFlareVolume,
  UpdateFlareVolume,
} from "src/entity/flare/flare-volume.entity";
import { utilsStore } from "src/stores/utils-store";
import { convertedDateRanges, covertedRangesDateToMinuteString } from "src/utils/date-time";
import VerticalCenter from "src/components/WrapCenter/VerticalCenter";
import { isNull, omit, omitBy, uniqBy } from "lodash";
import { reportFlareStore } from "src/stores/report-flare-volume-store";
import NumberRow from "./NumberRow";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { canEditTable } from "src/pages/VocsInventory/Flare/PermissionCheck/PermissionCheck";
import { optionsSelectYears } from "src/utils/array";
import Search, { SearchProps } from "antd/es/input/Search";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

const { Text } = Typography;
interface FlareVolumeTableProps {}

const FlareVolumeTable: React.FC<FlareVolumeTableProps> = ({}) => {
  const currentYear = new Date().getFullYear();
  const [messageApi, contextHolder] = message.useMessage();
  const [formSetupFlareVolume] = Form.useForm<FormSetUpFlareVolumeProps>();

  const prevCompany: any = useRef();

  const [selectedYear, setSelectedYear] = useState<string>(currentYear.toString());
  const [visibleModal, setVisibleModal] = useState(false);
  const [isEdit, setIsEdit] = useState<ResponseFlareVolume | null>(null);
  const [tableKey, setTableKey] = useState(0);
  const { permissions } = useNavigationMenu();

  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));

  const getAreaInCompany = utilsStore(useShallow((state) => state.getAreaInCompany));
  const dataAreaInCompany = utilsStore(useShallow((state) => state.dataAreaInCompany));

  const setLoadingAll = flareVolumeStore(useShallow((state) => state.setLoadingAll));
  const loadingAll = flareVolumeStore(useShallow((state) => state.loadingAll));

  const getAllHeatingValue = flareVolumeStore(useShallow((state) => state.getAllHeatingValue));
  const dataHeatingValueAll = flareVolumeStore(useShallow((state) => state.dataHeatingValueAll));
  const getAllSettingFlareInformation = flareVolumeStore(useShallow((state) => state.getAllSettingFlareInformation));
  const dataFlareInfo = flareVolumeStore(useShallow((state) => state.dataFlareInfo));
  const loadingFlareVolume = flareVolumeStore(useShallow((state) => state.loadingFlareVolume));
  const searchSetupFlareVolume = flareVolumeStore(useShallow((state) => state.searchSetupFlareVolume));
  const dataFlareVolume = flareVolumeStore(useShallow((state) => state.dataFlareVolume));
  const totalDocs = dataFlareVolume.total;
  const dataYear = flareVolumeStore(useShallow((state) => state.dataYear));
  const getFilterSetupFlareVolume = flareVolumeStore(useShallow((state) => state.getFilterSetupFlareVolume));
  const filterFlareVolume = flareVolumeStore(useShallow((state) => state.filterFlareVolume));
  const loadingManageFlareVolume = flareVolumeStore(useShallow((state) => state.loadingManageFlareVolume));
  const createSetupFlareVolume = flareVolumeStore(useShallow((state) => state.createSetupFlareVolume));
  const deleteSetupFlareVolume = flareVolumeStore(useShallow((state) => state.deleteSetupFlareVolume));
  const updateSetupFlareVolume = flareVolumeStore(useShallow((state) => state.updateSetupFlareVolume));
  const calculateReportFlareVolume = reportFlareStore(useShallow((state) => state.calculateReportFlareVolume));
  const setError = flareVolumeStore(useShallow((state) => state.setError));
  const clearError = flareVolumeStore(useShallow((state) => state.clearError));
  const errorFlareVolume = flareVolumeStore(useShallow((state) => state.errorFlareVolume));

  // Text Search
  const [textSearch, setTextSearch] = useState<string>("");
  const [searchTrigger, setSearchTrigger] = useState<number>(0);

  // console.log(" filterFlareVolume : ", filterFlareVolume);
  // console.log("dataHeatingValueAll : ");
  // console.log("data year : ", dataYear);

  const onClickEdit = (item: ResponseFlareVolume) => {
    const turnaroundPeriod = covertedRangesDateToMinuteString(item.turnaroundPeriod as RangeDateDto[]);
    const emergencyPeriod = covertedRangesDateToMinuteString(item.emergencyPeriod as RangeDateDto[]);
    const exceptionDate = covertedRangesDateToMinuteString(item.exceptionDate as RangeDateDto[]);

    formSetupFlareVolume.setFieldsValue({
      ...omit(item, ["exceptionDate", "turnaroundPeriod", "emergencyPeriod", "gasName", "area", "flareName"]),
      gasName: item?.gasName?.isActive ? item.gasName._id : undefined,
      area: getMasterLabel("area", item.area) ? item.area : undefined,
      flareName: item.flareName?.isActive ? item.flareName._id : undefined,
      turnaroundPeriod,
      emergencyPeriod,
      exceptionDate,
    });

    setIsEdit(item);
    setVisibleModal(true);
  };

  const deleteSetting = async (id: string) => {
    const confirm = await VocsModal.delete({
      message: "",
    });
    if (!confirm) return;
    deleteSetupFlareVolume(id).then(() => {
      messageApi.open({
        type: "success",
        content: CommonSuccess.DELETE_SUCCESSFULL,
      });
      processOnFinishAction();
    });
  };

  const mappingWarningText = (error: string, _: number): string => {
    return `• ${error}\n`;
  };

  const warningAlert = (message: string | string[]) => {
    const warnModal = AntModal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not save the data</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: typeof message === "string" ? `• ${message}` : message.map(mappingWarningText),
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const {
    onChange,
    filter,
    page,
    setPage,
    loading,
    limit: pageSize,
    setLimit: setPageSize,
    data: sourceData,
    replaceFilter,
  } = usePagination<ResponseFlareVolume, FilterSetupFlareVolume>({
    action: searchSetupFlareVolume,
    remoteData: dataFlareVolume.data,
    initialFilter: { year: [selectedYear] },
  });

  const getMasterLabel = (type: string, text: string) => {
    if (!text || typeof text != "string") return "";

    if (type === "gasName" && dataHeatingValueAll) {
      const optValue = dataHeatingValueAll.find((item) => item._id === text);
      return optValue?.gasName;
    } else if (type === "area" && dataAreaInCompany) {
      const optValue = dataAreaInCompany.find((item) => item._id === text);
      return optValue?.areaName;
    } else if (type === "flareName" && dataFlareInfo) {
      const optValue = dataFlareInfo.find((item) => item._id === text);
      return optValue?.flareName;
    } else return text;
  };

  const currentFilterExcludePage = useMemo(() => {
    const result = omitBy(filter, (value, key) => key === "page" || key === "year" || key === "limit" || isNull(value));
    return Object.keys(result).length;
  }, [filter]);

  const gasNameFilter = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return getFilterWithEmptyMasterdata(dataHeatingValueAll, filterFlareVolume.gasName, "gasName");
  }, [dataHeatingValueAll, filterFlareVolume.gasName, dataFlareVolume.data]);
  const sourceNameFilter = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.sourceName.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.sourceName, dataFlareVolume.data]);
  const areaFilter = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return getFilterWithEmptyMasterdata(dataAreaInCompany, filterFlareVolume.area, "areaName");
  }, [dataAreaInCompany, filterFlareVolume.area, dataFlareVolume.data]);

  const flareNameFilter = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return getFilterWithEmptyMasterdata(dataFlareInfo, filterFlareVolume.flareName, "flareName");
  }, [dataFlareInfo, filterFlareVolume.flareName, dataFlareVolume.data]);
  const filterInputBy = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.inputBy.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.inputBy, dataFlareVolume.data]);
  const filterVolumeBy = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.volumeBy.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.volumeBy, dataFlareVolume.data]);
  const filterTagPi = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.tagPi.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.tagPi, dataFlareVolume.data]);
  const filterHcVolume = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.hcVolume.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.hcVolume, dataFlareVolume.data]);
  const filterMaxFlow = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.maxFlow.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.maxFlow, dataFlareVolume.data]);
  const filterExceptionDate = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    const response = filterFlareVolume.exceptionDate.flatMap((item) => {
      if (item.length > 0)
        return item.flatMap((ele) => {
          return {
            text: `${ele.startDate} > ${ele.endDate}`,
            value: `${ele.startDate} > ${ele.endDate}`,
          };
        });
      else {
        return {
          text: ``,
          value: `empty_string > empty_string`,
        };
      }
    });
    return uniqBy(response, "value");
  }, [filterFlareVolume.exceptionDate, dataFlareVolume.data]);

  const filterTurnaroundPeriod = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    const response = filterFlareVolume.turnaroundPeriod.flatMap((item) => {
      if (item.length > 0)
        return item.flatMap((ele) => {
          return {
            text: `${ele.startDate} > ${ele.endDate}`,
            value: `${ele.startDate} > ${ele.endDate}`,
          };
        });
      else {
        return {
          text: ``,
          value: `empty_string > empty_string`,
        };
      }
    });
    return uniqBy(response, "value");
  }, [filterFlareVolume.turnaroundPeriod, dataFlareVolume.data]);

  const filterEmergencyPeriod = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    const response = filterFlareVolume.emergencyPeriod.flatMap((item) => {
      if (item.length > 0)
        return item.flatMap((ele) => {
          return {
            text: `${ele.startDate} > ${ele.endDate}`,
            value: `${ele.startDate} > ${ele.endDate}`,
          };
        });
      else {
        return {
          text: ``,
          value: `empty_string > empty_string`,
        };
      }
    });
    return uniqBy(response, "value");
  }, [filterFlareVolume.emergencyPeriod, dataFlareVolume.data]);

  const filterTagPiPortionToFlare = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.tagPiPortionToFlare.map((item: any) => {
      return {
        text: item ? item.join(", ") : item,
        value: item,
      };
    });
  }, [filterFlareVolume.tagPiPortionToFlare, dataFlareVolume.data]);
  const filterSentOneStackOfFlare = useMemo(() => {
    if (dataFlareVolume.data?.length === 0 && currentFilterExcludePage == 0) return [];
    return filterFlareVolume.sentOneStackOfFlare.map((item) => {
      return {
        text: item,
        value: item,
      };
    });
  }, [filterFlareVolume.sentOneStackOfFlare, dataFlareVolume.data]);

  const handleTableChange: TableProps<ResponseFlareVolume>["onChange"] = (_, filters) => {
    // console.log("FILTER :: ", filters);
    onChange(filters);
  };

  const getIndex = (index: number) => (page - 1) * pageSize + index;
  const renderPeriodRange = (ranges: RangeDateDto[]) => {
    if (!ranges || !ranges?.length) return <></>;

    return (
      <Row>
        <Col>
          {ranges.map((item, index) => {
            return (
              <Row key={index + "period"} className={`bg-white-500 border rounded-md ${index !== 0 ? "mt-2" : ""}`}>
                <Text className="p-1">
                  {item.startDate}
                  {" -> "}
                  {item.endDate}
                </Text>
              </Row>
            );
          })}
        </Col>
        <Col className="pl-2">
          <VerticalCenter>
            <CalendarOutlined style={{ fontSize: 18 }} />
          </VerticalCenter>
        </Col>
      </Row>
    );
  };

  const columns: TableProps<ResponseFlareVolume>["columns"] = [
    {
      title: "Source Name",
      dataIndex: "sourceName",
      key: "sourceName",
      render: (text) => <Text>{text}</Text>,
      filters: sourceNameFilter,
      align: "left",
    },
    {
      title: "Gas Name",
      dataIndex: "gasName",
      key: "gasName",
      render: (_, record) => <Text>{record?.gasName?.isActive === false ? "" : record?.gasName?.gasName}</Text>,
      filters: gasNameFilter,
      align: "left",
    },
    {
      title: "Area",
      dataIndex: "area",
      key: "area",
      render: (text) => <Text>{getMasterLabel("area", text)}</Text>,
      filters: areaFilter,
      align: "left",
    },
    {
      title: "Flare Name",
      key: "flareName",
      render: (_, record) => <Text>{record?.flareName?.isActive === false ? "" : record?.flareName?.flareName}</Text>,
      filters: flareNameFilter,
      align: "left",
    },
    {
      title: "Calculation Method",
      dataIndex: "calculationMethod",
      render: (text) => <Text>{text}</Text>,
      align: "left",
    },
    {
      title: "Input By",
      dataIndex: "inputBy",
      render: (text) => <Text>{text}</Text>,
      filters: filterInputBy,
      align: "left",
    },
    // {
    //   title: "% HC Volume",
    //   dataIndex: "hcVolume",
    //   key: "hcVolume",
    //   render: (text) => <Text>{text}</Text>,
    //   filters: filterHcVolume,
    //   align: "left",
    // },
    // {
    //   title: "Volume By",
    //   dataIndex: "volumeBy",
    //   key: "volumeBy",
    //   render: (text) => <Text>{text}</Text>,
    //   filters: filterVolumeBy,
    //   align: "left",
    // },
    // {
    //   title: "Max Flow (Kg/h)",
    //   dataIndex: "maxFlow",
    //   key: "maxFlow",
    //   render: (text) => <Text>{formatNumber(text)}</Text>,
    //   filters: filterMaxFlow,
    //   align: "left",
    // },
    // {
    //   title: "Tag PI",
    //   dataIndex: "tagPi",
    //   key: "tagPi",
    //   render: (text) => <Text>{text}</Text>,
    //   filters: filterTagPi,
    //   align: "left",
    // },
    // {
    //   title: "Sent one stack of flare",
    //   dataIndex: "sentOneStackOfFlare",
    //   key: "sentOneStackOfFlare",
    //   render: (text) => <Text>{text}</Text>,
    //   filters: filterSentOneStackOfFlare,
    //   align: "left",
    // },
    // {
    //   title: "Tag PI Portion to flare",
    //   key: "tagPiPortionToFlare",
    //   render: (_, record) => (
    //     <Col>
    //       {record.tagPiPortionToFlare && record.tagPiPortionToFlare?.length ? (
    //         <>
    //           {record.tagPiPortionToFlare.map((item, ind) => (
    //             <Row key={"tag-pi-portion-wrap" + ind}>
    //               <Text>
    //                 {getMasterLabel("flareName", item.flareName)} - {item.tagPi.join(", ")}
    //               </Text>
    //             </Row>
    //           ))}
    //         </>
    //       ) : (
    //         <Text>-</Text>
    //       )}
    //     </Col>
    //   ),
    //   filters: filterTagPiPortionToFlare,
    //   align: "left",
    // },
    // {
    //   title: "Turnaround Period",
    //   dataIndex: "turnaroundPeriod",
    //   key: "turnaroundPeriod",
    //   render: (_, record) => renderPeriodRange(record.turnaroundPeriod as RangeDateDto[]),
    //   filters: filterTurnaroundPeriod,
    //   align: "left",
    // },
    // {
    //   title: "Emergency Period",
    //   dataIndex: "emergencyPeriod",
    //   key: "emergencyPeriod",
    //   render: (_, record) => renderPeriodRange(record.emergencyPeriod as RangeDateDto[]),
    //   filters: filterEmergencyPeriod,
    //   align: "left",
    // },
    // {
    //   title: "Exception Date",
    //   dataIndex: "exceptionDate",
    //   key: "exceptionDate",
    //   render: (_, record) => renderPeriodRange(record.exceptionDate as RangeDateDto[]),
    //   filters: filterExceptionDate,
    //   align: "left",
    // },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space size="middle" direction={"horizontal"}>
          <Button
            className="border-transparent bg-transparent"
            size={"small"}
            onClick={() => onClickEdit(record)}
            disabled={!canEditTable(permissions)}
          >
            <BsPencilSquare size={18} />
          </Button>
          <Button
            className="border-transparent bg-transparent"
            size={"small"}
            onClick={() => deleteSetting(record._id)}
            disabled={record.isAllProcessing === false || !canEditTable(permissions)}
          >
            <BsTrashFill size={18} />
          </Button>
        </Space>
      ),
      align: "left",
    },
  ];

  const initialRequestDidMount = async (isDidMount?: boolean) => {
    setLoadingAll(true);
    const getAreaInCompanyPromise = getAreaInCompany(profile?.activeCompany._id as string);
    const getAllSettingFlareInformationPromise = getAllSettingFlareInformation(); // SetUp Flare Info Menu
    const getAllHeatingValuePromise = getAllHeatingValue(selectedYear); // HeatingValue Menu
    const getFilterSetupFlareVolumePromise = getFilterSetupFlareVolume(selectedYear);
    const searchSetupFlareVolumePromise = searchSetupFlareVolume(
      isDidMount === true ? { ...filter, page, limit: pageSize, year: [selectedYear] } : { page, limit: pageSize, year: [selectedYear] },
    );
    await Promise.all([
      getAreaInCompanyPromise,
      getAllSettingFlareInformationPromise,
      getAllHeatingValuePromise,
      getFilterSetupFlareVolumePromise,
      searchSetupFlareVolumePromise,
    ]);
    setLoadingAll(false);
  };

  useDidMount(() => {
    prevCompany.current = profile?.activeCompany._id;
    initialRequestDidMount(true);
  });

  useEffect(() => {
    if (profile?.activeCompany) {
      if (prevCompany.current !== profile.activeCompany._id) {
        replaceFilter({ year: [currentYear.toString()] });
        setSelectedYear(currentYear.toString());
        prevCompany.current = profile?.activeCompany._id;
      }
      setPage(1);
      setTableKey(tableKey + 1);
      setTextSearch("");
    }
  }, [profile?.activeCompany, selectedYear]);

  useEffect(() => {
    if (tableKey > 0) {
      initialRequestDidMount();
    }
  }, [tableKey]);

  useEffect(() => {
    searchSetupFlareVolume({ ...filter, textSearch, page: 1, limit: pageSize, year: [selectedYear] });
  }, [searchTrigger]);

  const onChangePage = (val: number) => {
    setPage(val);
  };

  const paginationProps: PaginationProps = {
    size: "small",
    pageSize: pageSize,
    current: page,
    total: totalDocs || 0,
    defaultCurrent: 1,
    onChange: onChangePage,
    showSizeChanger: false,
  };

  const onAddFlareInfo = () => {
    setVisibleModal(true);
  };

  const closeModal = () => {
    setVisibleModal(false);
    formSetupFlareVolume.resetFields();
    clearError("errorFlareVolume");
    setIsEdit(null);
  };

  const calculateHeatingValue = (data: ManageCompoundProps[]) => {
    let sumHtvMole = 0;
    data
      .filter((item) => item.compound && item.mole)
      .forEach((item) => {
        const heatingValue: number = parseToDecimal(item.heatingValue);
        const mole: number = parseToDecimal(item.mole);
        const multiply: number = heatingValue * mole;
        sumHtvMole += multiply;
      });
    const result = sumHtvMole / 100;
    return result.toFixed(2);
  };

  const submitSetupHeatingValue = async () => {
    let checkError = false;
    await formSetupFlareVolume.validateFields().catch(() => {
      checkError = true;
    });
    if (checkError) return;

    const formData = formSetupFlareVolume.getFieldsValue();
    // console.log("formData : ", formData);
    if (
      formData.sentOneStackOfFlare === SentOneStackOfFlareEnum.NO &&
      (!formData.tagPiPortionToFlare || !formData.tagPiPortionToFlare?.length)
    ) {
      setError("errorFlareVolume", "Please input at least one tagPI portion to flare.");
      return;
    } else if (
      formData.sentOneStackOfFlare === SentOneStackOfFlareEnum.NO &&
      formData.tagPiPortionToFlare &&
      formData.tagPiPortionToFlare.length
    ) {
      const findMatchOfFlare = formData.tagPiPortionToFlare.find((item) => item.flareName === formData.flareName);
      if (!findMatchOfFlare) {
        setError("errorFlareVolume", "Please select a matching flare name.");
        return;
      }
    }
    // console.log("form data ; ", formData);
    // console.log("manage compound : ", manageCompound);
    const formatData: any = trimAllKey(replaceUndefinedWithNull(formData as any), []);
    const turnaroundPeriodFormat = formatData?.turnaroundPeriod ? convertedDateRanges(formatData.turnaroundPeriod) : [];
    const emergencyPeriodFormat = formatData?.emergencyPeriod ? convertedDateRanges(formatData.emergencyPeriod) : [];
    const exceptionDateFormat = formatData?.exceptionDate ? convertedDateRanges(formatData.exceptionDate) : [];

    // console.log("All parse date range : ", { turnaroundPeriodFormat, emergencyPeriodFormat, exceptionDateFormat });
    const finalData: CreateFlareVolume = {
      ...(formatData as CreateFlareVolume),
      turnaroundPeriod: turnaroundPeriodFormat,
      emergencyPeriod: emergencyPeriodFormat,
      exceptionDate: exceptionDateFormat,
      year: selectedYear.toString(),
      companyId: profile?.activeCompany._id as string,
      isActive: true,
    };
    if (!("tagPiPortionToFlare" in finalData)) {
      finalData["tagPiPortionToFlare"] = [];
    }

    // console.log("Final data : ", finalData);
    if (isEdit) {
      updateSetupFlareVolume({ ...finalData, _id: isEdit._id }).then(onFinishAction);
    } else createSetupFlareVolume(finalData).then(onFinishAction);
  };

  const handleChangeYear = (year: string) => {
    // console.log("Year : ", year);
    replaceFilter({ year: [year] });
    setSelectedYear(year);
  };

  const onFinishAction = (response?: unknown) => {
    // console.log("response : ", { isEdit, response });
    if (response && typeof response === "string") {
      // warningAlert(response as string);
      formSetupFlareVolume.setFields([
        {
          name: "sourceName",
          errors: [""],
        },
        {
          name: "gasName",
          errors: [""],
        },
        {
          name: "area",
          errors: [""],
        },
        {
          name: "flareName",
          errors: [""],
        },
      ]);
      return;
    } else {
      if (isEdit?._id) calculateReportFlareVolume(isEdit?._id as string);
      else calculateReportFlareVolume((response as UpdateFlareVolume)._id as string);
      messageApi.open({
        type: "success",
        content: CommonSuccess.SAVED_SUCCESSFULL,
      });
      processOnFinishAction();
    }
  };

  const processOnFinishAction = () => {
    getFilterSetupFlareVolume(selectedYear);
    searchSetupFlareVolume({ ...filter, page, limit: pageSize, year: [selectedYear] });
    closeModal();
  };

  const processRowClassName = useCallback(
    (record: ResponseFlareVolume) => {
      const hasGasName = record?.gasName?.isActive;
      const hasArea = dataAreaInCompany.find((item) => item._id === record.area);
      const hasFlareName = dataFlareInfo.find((item) => item._id === record.flareName._id);
      // console.log("Details row class Name : ", { hasGasName, hasArea });
      return !hasGasName || !hasArea || !hasFlareName ? "red-border-row" : "";
    },
    [selectedYear, dataHeatingValueAll, sourceData, dataAreaInCompany, dataFlareInfo],
  );

  const onSearch: SearchProps["onSearch"] = (value, _e) => {
    setTextSearch(value);
    setSearchTrigger((prev) => prev + 1);
  };

  return (
    <Row className="w-full" id={"wrap-flare-volume-table"}>
      {contextHolder}
      <Row className="w-full" justify={"space-between"}>
        <Select value={selectedYear} style={{ width: 120 }} onChange={handleChangeYear} options={optionsSelectYears()} size="middle" />
        <Search onSearch={onSearch} style={{ width: 250 }} value={textSearch} onChange={(e) => setTextSearch(e.target.value)} allowClear />
        <Button
          type={"primary"}
          size={"middle"}
          className="flex items-center"
          onClick={onAddFlareInfo}
          style={{ visibility: canEditTable(permissions) ? "visible" : "hidden" }}
        >
          <PlusCircleOutlined />
          New
        </Button>
      </Row>
      <Table
        key={tableKey}
        columns={addCenterAlign(columns)}
        dataSource={sourceData as ResponseFlareVolume[]}
        className="w-full mt-4"
        loading={loadingProfile || loadingAll || loading || loadingFlareVolume}
        rowKey="_id"
        scroll={{ x: "max-content" }}
        pagination={false}
        onChange={handleTableChange}
        rowClassName={processRowClassName} // Apply red border conditionally
      />

      <Row className="w-full mt-4" justify={"end"}>
        <Pagination {...paginationProps} />
      </Row>

      <FlareVolumeModal
        submitSetupHeatingValue={submitSetupHeatingValue}
        loadingManageFlareVolume={loadingManageFlareVolume}
        visibleModal={visibleModal}
        closeModal={closeModal}
        errorFlareVolume={errorFlareVolume}
        formSetupFlareVolume={formSetupFlareVolume}
        calculateHeatingValue={calculateHeatingValue}
        isEdit={isEdit ? true : false}
      />
    </Row>
  );
};

export default FlareVolumeTable;
